import { useState, useRef, useCallback, useLayoutEffect } from 'react';

// source: https://github.com/thomasthiebaud/react-use-size/blob/master/src/useComponentSize.ts
export const useComponentSize = () => {
  const [size, setSize] = useState({
    height: 0,
    width: 0,
  });
  const ref = useRef();

  const onResize = useCallback(() => {
    if (!ref.current) {
      return;
    }

    const newHeight = ref.current.offsetHeight;
    const newWidth = ref.current.offsetWidth;

    if (newHeight !== size.height || newWidth !== size.width) {
      setSize({
        height: newHeight,
        width: newWidth,
      });
    }
  }, [size.height, size.width]);

  useLayoutEffect(() => {
    if (!ref || !ref.current) {
      return;
    }

    const resizeObserver = new ResizeObserver(onResize);
    resizeObserver.observe(ref.current);

    return () => resizeObserver.disconnect();
  }, [ref, onResize]);

  return {
    ref,
    ...size,
  };
};
